// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AzFOl","option":"styles_option__2kglz","selected":"styles_selected__3TtEj"};